export const NAV_BAR_ITEMS_SEEK = [
  {
    label: "Services",
    path: "/gigs/listings",
  },
  {
    label: "Services",
    path: "/listings",
  },
];

export const NAV_BAR_ITEMS_PROVIDE = [
  {
    label: "Dashboard",
    path: "/gigs/dashboard",
  },
  {
    label: "Catalogue",
    path: "/gigs/catalogue",
  },
  {
    label: "Catalogue",
    path: "/catalogue",
  },
  {
    label: "Courses",
    path: "/gigs/course",
  },
  {
    label: "Earnings",
    path: "/gigs/earnings",
  },
];

export const NAV_BAR_ITEMS_COMMON = [
  {
    label: "Conversations",
    path: "/conversations",
  },
  {
    label: "Calendar",
    path: "/gigs/calendar",
    key: "calendar",
  },
];

export const MODE_PROVIDE = "PROVIDE";
export const MODE_SEEK = "SEEK";

export const NAV_BAR_ITEMS = {
  [MODE_PROVIDE]: [...NAV_BAR_ITEMS_PROVIDE, ...NAV_BAR_ITEMS_COMMON],
  [MODE_SEEK]: [...NAV_BAR_ITEMS_SEEK, ...NAV_BAR_ITEMS_COMMON],
};

export const DEFAULT_PROVIDE_PATH = NAV_BAR_ITEMS_PROVIDE[1].path;
export const DEFAULT_SEEK_PATH = NAV_BAR_ITEMS_SEEK[0].path;

// Bottom bar action states.
export const BOTTOM_BAR_ACTION_OPT_IN = "OPT_IN";
export const BOTTOM_BAR_ACTION_EDIT = "EDIT";
export const BOTTOM_BAR_ACTION_CUSTOMIZE = "CUSTOMIZE";
export const BOTTOM_BAR_ACTION_MESSAGE = "MESSAGE";
export const BOTTOM_BAR_ACTION_NOTIFY_ME = "Notify Me";
export const BOTTOM_BAR_ACTION_TRY_NOW = "Try Now";

export const KEY_MAP = (hasProfileCredentials) => {
  return {
    [DELIVERY_FORMAT.ONE_ON_ONE]: [
      ["description"],
      ["duration", "meetingType"],
      ["availability"],
      [
        "price",
        "servicesIncludeByPrice",
        "servicesNotIncludeByPrice",
        "discount",
      ],
      ["agenda"],
      ["whoShouldBook"],
      ["autoReplyMessage"],
      ["aboutMe"],
      ...(hasProfileCredentials ? [["credentials"]] : []),
    ],
    [DELIVERY_FORMAT.LIVE_CLASSROOM]: [
      ["description"],
      ["course"],
      ["batches"],
      ["price", "discount"],
      ["studentsWillLearnDelta"],
      ...(hasProfileCredentials ? [["credentials"]] : []),
      ["aboutMe"],
      ["media"], // thumbnail images
    ],
    [DELIVERY_FORMAT.LEARNING_CONTENT]: [
      ["description"],
      ["course"],
      ["courseWithTeaserVideos"],
      ["price", "discount"],
      ["studentsWillLearn"],
      ["addOns"],
      ["credentials"],
      ["aboutMe"],
      ["media"], // thumbnail images
    ],
    [DELIVERY_FORMAT.TALK]: [
      ["description"],
      ["talks"],
      ["price", "discount"],
      ...(hasProfileCredentials ? [["credentials"]] : []),
      ["aboutMe"],
      ["whoShouldBook"],
      ["media"], // thumbnail images
    ],
    [DELIVERY_FORMAT.APP]: [
      ["description"],
      ["aboutMe"],
      ["appLink"],
      ["media"],
    ],
    [DELIVERY_FORMAT.MEETUP]: [
      ["description"],
      ["talks"],
      ["price", "discount"],
      ...(hasProfileCredentials ? [["credentials"]] : []),
      ["aboutMe"],
      ["whoShouldBook"],
      ["media"], // thumbnail images
    ],
    [DELIVERY_FORMAT.CLASSIFIED]: [
      ["listedGood"],
      ["listedGood"],
      ["description"],
      ["agenda"],
      ["price", "discount", "listedGood"],
      ...(hasProfileCredentials ? [["credentials"]] : []),
      ["aboutMe"],
      ["whoShouldBook"],
      ["autoReplyMessage"],
      ["media"],
    ],
    [DELIVERY_FORMAT.ASSESSMENT]: [
      ["description"],
      ["assessments"],
      ["price", "discount"],
      ...(hasProfileCredentials ? [["credentials"]] : []),
      ["aboutMe"],
      ["whoShouldBook"],
      ["studentsWillLearn"],
      ["media"], // thumbnail images
    ],
  };
};

// This list is sorted according to the order of Priority
export const DELIVERY_FORMAT = {
  ALL: 0,
  ONE_ON_ONE: 1,
  LIVE_CLASSROOM: 2,
  LEARNING_CONTENT: 3,
  TALK: 4,
  APP: 5,
  MEETUP: 6,
  CLASSIFIED: 7,
  ASSESSMENT: 8,
};

export const DELIVERY_FORMAT_EVENTS = {
  TALK: 4,
  MEETUP: 6,
};

export const DELIVERY_FORMAT_SERVICES = {
  ONE_ON_ONE: 1,
  LIVE_CLASSROOM: 2,
  CLASSIFIED: 7,
  ASSESSMENT: 8,
};

export const DELIVERY_FORMAT_MAP = {
  1: "1:1 Session",
  2: "Live Classroom",
  3: "Learning Content",
  4: "Nbyula Talk",
  5: "App",
  6: "Meetup",
  7: "Classified",
  8: "Assessment",
};

export const GIG_LISTING_STATUS_DRAFT = "Draft";
export const GIG_LISTING_STATUS_ACTIVE = "Active";
export const GIG_LISTING_STATUS_PAUSED = "Paused";
export const GIG_LISTING_STATUS_IN_REVIEW = "In review";
export const GIG_LISTING_STATUS_DELETED = "Deleted";

export const GIG_LISTING_STATUS = {
  1: GIG_LISTING_STATUS_DRAFT,
  2: GIG_LISTING_STATUS_ACTIVE,
  3: GIG_LISTING_STATUS_PAUSED,
  4: GIG_LISTING_STATUS_IN_REVIEW,
  5: GIG_LISTING_STATUS_DELETED,
};

export const GIG_LISTING_STATUS_MAP = {
  DRAFT: 1,
  ACTIVE: 2,
  PAUSED: 3,
  REVIEW: 4,
  DELETED: 5,
};

export const GIG_DETAIL_INTENT_CONVERSATION = "CONVERSATION";
export const GIG_DETAIL_INTENT_PAYMENT = "PAYMENT";
export const GIG_DETAIL_INTENT_INTERESTED = "INTERESTED";
export const GIG_DETAIL_INTENT_INTERESTED_IN_RECORDING =
  "INTERESTED_IN_RECORDING";

export const GIG_SEAT_SERVICES = {
  1: "Networking Zone",
  2: "Live Q&A",
  3: "Playback Recording",
};

export const GIG_SEAT_SERVICES_MAP_TO_VALUE = {
  "Networking Zone": 1,
  "Live Q&A": 2,
  "Playback Recording": 3,
};
export const GIG_ALREADY_BOUGHT = "BOUGHT_ALREADY";
export const PAYMENT_FAILURE = "FAILURE";
export const PAYMENT_SUCCESS = "SUCCESS";

export const GIG_BOOKING_FLOW_STAGE = {
  DEFAULT: 1,
  SELECT_SEAT: 2,
  INVITE_OTHERS: 3,
  CLAIM_YOUR_SEAT: 4,
  PAYMENT_COMPLETED: 5,
  PROVIDER_VIEW: 6,
  SELECT_BATCH: 7,
};

export const GIG_SUBSCRIPTION_ALERTS = {
  "REMAINING-SEATS": "REMAINING-SEATS",
  "AWAITING-SIGNUP": "AWAITING-SIGNUP",
};

export const GIG_LISTINGS_MEDIA_TYPE = {
  IMAGE: "IMAGE",
  VIDEO: "VIDEO",
  VIMEO: "VIMEO",
};

export const FEEDBACK_PRE_FABRICATED_REVIEWS = {
  ONE_STAR: "Not satisfied. Won’t recommend.",
  TWO_STAR: "Not satisfied. Won’t recommend.",
  THREE_STAR: "It was okay, but can improve.",
  FOUR_STAR: "Highly recommended. It was insightful.",
  FIVE_STAR: "Highly recommended. It was insightful.",
};

export const FEEDBACK_STARS_REVIEWS = [
  FEEDBACK_PRE_FABRICATED_REVIEWS.ONE_STAR,
  FEEDBACK_PRE_FABRICATED_REVIEWS.TWO_STAR,
  FEEDBACK_PRE_FABRICATED_REVIEWS.THREE_STAR,
  FEEDBACK_PRE_FABRICATED_REVIEWS.FOUR_STAR,
  FEEDBACK_PRE_FABRICATED_REVIEWS.FIVE_STAR,
];

export const GIG_CLASSIFIED_GOOD_TYPES = {
  DIGITAL: 1,
  PHYSICAL: 2,
};

export const GIG_CLASSIFIED_GOOD_CATEGORIES = [
  {
    type: GIG_CLASSIFIED_GOOD_TYPES.DIGITAL,
    category: "d-practice-test",
    label: "Practice Test",
  },
  {
    type: GIG_CLASSIFIED_GOOD_TYPES.DIGITAL,
    category: "d-e-book",
    label: "E Book",
  },
  {
    type: GIG_CLASSIFIED_GOOD_TYPES.DIGITAL,
    category: "d-audio-book",
    label: "Audio Book",
  },
  {
    type: GIG_CLASSIFIED_GOOD_TYPES.DIGITAL,
    category: "d-exam-paper",
    label: "Exam Paper",
  },
  {
    type: GIG_CLASSIFIED_GOOD_TYPES.DIGITAL,
    category: "d-study-notes",
    label: "Study Notes",
  },
  {
    type: GIG_CLASSIFIED_GOOD_TYPES.DIGITAL,
    category: "d-others",
    label: "Other Digital Goods",
  },
  {
    type: GIG_CLASSIFIED_GOOD_TYPES.PHYSICAL,
    category: "p-practice-test",
    label: "Practice Test",
  },
  {
    type: GIG_CLASSIFIED_GOOD_TYPES.PHYSICAL,
    category: "p-book",
    label: "Book",
  },
  {
    type: GIG_CLASSIFIED_GOOD_TYPES.PHYSICAL,
    category: "p-exam-paper",
    label: "Exam Paper",
  },
  {
    type: GIG_CLASSIFIED_GOOD_TYPES.PHYSICAL,
    category: "p-study-notes",
    label: "Study Notes",
  },
  {
    type: GIG_CLASSIFIED_GOOD_TYPES.PHYSICAL,
    category: "p-others",
    label: "Other Physical Goods",
  },
];

// ---------------------------------------------

export const POPULAR_CATEGORIES = [
  {
    categoryName: "Study Abroad",
    categoryImage: "/home/popular-categories/study-abroad.webp",
    categoryImageMobile: "/home/popular-categories/study-abroad-mobile.webp",
    subCategories: [
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Destination Selection",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Program Selection",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "SOP Assistance",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "LOR Assistance",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Application Filing",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "GPA/Credit Conversion",
      },
    ],
  },
  {
    categoryName: "Work Abroad",
    categoryImage: "/home/popular-categories/work-abroad.webp",
    categoryImageMobile: "/home/popular-categories/work-abroad-mobile.webp",
    subCategories: [
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Profile Evaluation",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Resume & Cover Letter",
      },
    ],
  },
  {
    categoryName: "Entrance Exam Preparation",
    categoryImage: "/home/popular-categories/exam-prep.webp",
    categoryImageMobile: "/home/popular-categories/exam-prep-mobile.webp",
    subCategories: [
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "SAT",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "GRE",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "GMAT",
      },
    ],
  },
  {
    categoryName: "Language Preparation",
    categoryImage: "/home/popular-categories/language-prep.webp",
    categoryImageMobile: "/home/popular-categories/language-prep-mobile.webp",
    subCategories: [
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Learn German",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "IELTS Preparation",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "TOEFL Preparation",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Learn Spanish",
      },
    ],
  },
  {
    categoryName: "Education Financing",
    categoryImage: "/home/popular-categories/education-finance.webp",
    categoryImageMobile:
      "/home/popular-categories/education-finance-mobile.webp",
    subCategories: [
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Scholarships",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Loans",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "International Payments",
      },
    ],
  },
  {
    categoryName: "Visa & Immigration",
    categoryImage: "/home/popular-categories/visa-immigration.webp",
    categoryImageMobile:
      "/home/popular-categories/visa-immigration-mobile.webp",
    subCategories: [
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Visa Advisory",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Document Preparation",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Visa Interview Preparation",
      },
    ],
  },
  {
    categoryName: "Post Landing Support",
    categoryImage: "/home/popular-categories/post-landing.webp",
    categoryImageMobile: "/home/popular-categories/post-landing-mobile.webp",
    subCategories: [
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Accommodation",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Part Time Jobs",
      },
      {
        subCategoryImage:
          "/sub-categories/educational-financing/scholarships.webp",
        subCategoryName: "Internships",
      },
    ],
  },
];

export const FEATURED_MENTORS = [
  {
    mentorImage: "/home/featured-mentors/mentorOne.webp",
    mentorName: "Sarah Isaac",
    mentorSpecialization: "IELTS Trainer",
  },
  {
    mentorImage: "/home/featured-mentors/mentorTwo.webp",
    mentorName: "Jessie Johnson",
    mentorSpecialization: "Max Weber Fellow",
  },
  {
    mentorImage: "/home/featured-mentors/mentorThree.webp",
    mentorName: "Sarah Fell",
    mentorSpecialization: "Michigan University",
  },
  {
    mentorImage: "/home/featured-mentors/mentorFour.webp",
    mentorName: "Carl Berret",
    mentorSpecialization: "Imperial College of London",
  },
];

export const BANNER_MENTORS = [
  {
    mentorFullName: "Maitri D",
    mentorSpecialization: "Spanish Language Trainer",
    mentorImage: "/assets/images/mentor-1.webp",
    totalBookings: "737",
    mentorAssociatedBackground: "#863857",
    username: "maitri-2",
  },
  {
    mentorFullName: "Vinayak Unnithan",
    mentorSpecialization: "Imperial College London",
    mentorImage: "/assets/images/mentor-2.webp",
    totalBookings: "1265",
    mentorAssociatedBackground: "#006862",
    username: "vinayak-17",
  },
  {
    mentorFullName: "Nitin Agrawal",
    mentorSpecialization: "University of Oxford",
    mentorImage: "/assets/images/mentor-3.webp",
    totalBookings: "1264",
    mentorAssociatedBackground: "#037f8f",
    username: "nitin-31",
  },
];

export const MENTOR_ASSOCIATIONS = [
  "/home/mentor-associations/economics.webp",
  "/home/mentor-associations/oxford.webp",
  "/home/mentor-associations/imperial.webp",
  "/home/mentor-associations/queen-marry.webp",
  "/home/mentor-associations/commonwealth.webp",
  "/home/mentor-associations/leeds.webp",
  "/home/mentor-associations/edinburgh.webp",
  "/home/mentor-associations/bristol.webp",
  "/home/mentor-associations/nottingham.webp",
  "/home/mentor-associations/tudelft.webp",
  "/home/mentor-associations/freie.webp",
];

export const EXPLORE_CATEGORIES = [
  {
    categoryName: "Study Abroad",
    categorySlug: "study-abroad",
    categoryImage: "/home/popular-categories/study-abroad.webp",
    categoryImageMobile: "/home/popular-categories/study-abroad-mobile.webp",
    categorySubCategory: [
      "Destination Selection",
      "Program Selection",
      "SOP Assistance",
      "LOR Assistance",
      "Application Filing",
      "GPA/Credit Conversion",
    ],
  },
  {
    categoryName: "Work Abroad",
    categorySlug: "work-abroad",
    categoryImage: "/home/popular-categories/work-abroad.webp",
    categoryImageMobile: "/home/popular-categories/study-abroad-mobile.webp",
    categorySubCategory: [
      "Profile Evaluation",
      "Resume & Cover Letter",
      "International Job Search",
    ],
  },
  // {
  //   categoryName: "Entrance Exam Preparation",
  //   categorySlug: "entrance-exam-preparation",
  //   categoryImage: "/home/popular-categories/exam-prep.webp",
  //   categoryImageMobile: "/home/popular-categories/exam-prep-mobile.webp",
  //   categorySubCategory: ["SAT", "GRE", "GMAT"],
  // },
  {
    categoryName: "Language Preparation",
    categorySlug: "language-preparation",
    categoryImage: "/home/popular-categories/language-prep.webp",
    categoryImageMobile: "/home/popular-categories/language-prep-mobile.webp",
    categorySubCategory: [
      "Learn German",
      "IELTS Preparation",
      "TOEFL Preparation",
      "Learn Spanish",
    ],
  },
  {
    categoryName: "Education Financing",
    categorySlug: "education-financing",
    categoryImage: "/home/popular-categories/education-finance.webp",
    categoryImageMobile:
      "/home/popular-categories/education-finance-mobile.webp",
    categorySubCategory: ["Scholarships", "Loans", "International Payments"],
  },
  {
    categoryName: "Visa & Immigration",
    categorySlug: "visa-immigration",
    categoryImage: "/home/popular-categories/visa-immigration.webp",
    categoryImageMobile:
      "/home/popular-categories/visa-immigration-mobile.webp",
    categorySubCategory: [
      "Visa Advisory",
      "Document Preparation",
      "Visa Interview Preparation",
    ],
  },
  {
    categoryName: "Post Landing Support",
    categorySlug: "post-landing-support",
    categoryImage: "/home/popular-categories/post-landing.webp",
    categoryImageMobile: "/home/popular-categories/post-landing-mobile.webp",
    categorySubCategory: ["Accommodation", "Part Time Jobs", "Internships"],
  },
];

export const CATEGORY_BANNERS = {
  "Study Abroad": {
    desktop: [
      "/category-banners/study-abroad-1.webp",
      "/category-banners/study-abroad-2.webp",
      "/category-banners/study-abroad-3.webp",
    ],
    mobile: [
      "/category-banners/study-abroad-1-mobile.webp",
      "/category-banners/study-abroad-2-mobile.webp",
      "/category-banners/study-abroad-3-mobile.webp",
    ],
    links: [
      "/gigs/listings/nbyulasupport1/all-in-one-study-abroad-package-2",
      "/category/study-abroad/program-selection",
      "/gigs/listings/nbyulasupport1/all-in-one-study-abroad-package-2",
    ],
  },
  "Education Financing": {
    desktop: [
      "/category-banners/education-financing-1.webp",
      "/category-banners/education-financing-2.webp",
      "/category-banners/education-financing-3.webp",
    ],
    mobile: [
      "/category-banners/education-financing-1-mobile.webp",
      "/category-banners/education-financing-2-mobile.webp",
      "/category-banners/education-financing-3-mobile.webp",
    ],
    links: [
      "/gigs/listings/nbyulasupport1/can-you-get-a-scholarship-abroad-%7C-free-eligibility-check-1",
      "/gigs/listings/nbyulasupport1/can-you-get-a-scholarship-abroad-%7C-free-eligibility-check-1",
      "/gigs/listings/nbyulasupport1/can-you-get-a-scholarship-abroad-%7C-free-eligibility-check-1",
    ],
  },
  "Work Abroad": {
    desktop: [
      "/category-banners/work-abroad-1.webp",
      "/category-banners/work-abroad-2.webp",
      "/category-banners/work-abroad-3.webp",
    ],
    mobile: [
      "/category-banners/work-abroad-1-mobile.webp",
      "/category-banners/work-abroad-2-mobile.webp",
      "/category-banners/work-abroad-3-mobile.webp",
    ],
    links: [
      "/jobs",
      "/gigs/listings/nbyulasupport1/profile-evaluation-for-global-jobs-pr-1",
      "/jobs",
    ],
  },
  "Language Preparation": {
    desktop: [
      "/category-banners/language-preparation-1.webp",
      "/category-banners/language-preparation-2.webp",
      "/category-banners/language-preparation-3.webp",
    ],
    mobile: [
      "/category-banners/language-preparation-1-mobile.webp",
      "/category-banners/language-preparation-2-mobile.webp",
      "/category-banners/language-preparation-3-mobile.webp",
    ],
    links: [
      "/gigs/listings/sarah2/ielts-accelerator-course-1",
      "/gigs/listings/adel-3/complete-a1-german-language-preparation-1",
      "/category/language-preparation/ielts-preparation",
    ],
  },
  "Post Landing Support": {
    desktop: [
      "/category-banners/post-landing-support-1.webp",
      "/category-banners/post-landing-support-2.webp",
      "/category-banners/post-landing-support-3.webp",
    ],
    mobile: [
      "/category-banners/post-landing-support-1-mobile.webp",
      "/category-banners/post-landing-support-2-mobile.webp",
      "/category-banners/post-landing-support-3-mobile.webp",
    ],
    links: [
      "/gigs/listings/shivansh1/ill-clear-all-your-queries-about-life-in-a-new-country-1",
      "/jobs",
      "/jobs",
    ],
  },
  "Visa & Immigration": {
    desktop: [
      "/category-banners/visa-immigration-1.webp",
      "/category-banners/visa-immigration-2.webp",
      "/category-banners/visa-immigration-3.webp",
    ],
    mobile: [
      "/category-banners/visa-immigration-1-mobile.webp",
      "/category-banners/visa-immigration-2-mobile.webp",
      "/category-banners/visa-immigration-3-mobile.webp",
    ],
    links: [
      "/gigs/listings/shivansh1/ill-answer-all-your-visa-related-queries-1",
      "/category/visa-immigration/visa-advisory",
      "/gigs/listings/shivansh1/ill-answer-all-your-visa-related-queries-1",
    ],
  },
  "Entrance Exam Preparation": {
    desktop: [
      "/category-banners/educational-financing-1.webp",
      "/category-banners/educational-financing-2.webp",
      "/category-banners/educational-financing-3.webp",
    ],
    mobile: [
      "/category-banners/educational-financing-1-mobile.webp",
      "/category-banners/educational-financing-2-mobile.webp",
      "/category-banners/educational-financing-3-mobile.webp",
    ],
  },
};

export const CATEGORY_NAME_TO_SLUG_MAP = {
  "Study Abroad": "study-abroad",
  "Work Abroad": "work-abroad",
  "Education Financing": "educational-financing",
  "Language Preparation": "language-preparation",
  "Post Landing Support": "post-landing-support",
  "Visa & Immigration": "visa-immigration",
  "Entrance Exam Preparation": "entrance-exam-preparation",
  "Destination Selection": "destination-selection",
  "Program Selection": "program-selection",
  "SOP Assistance": "sop-assistance",
  "LOR Assistance": "lor-assistance",
  "Application Filing": "application-filing",
  "GPA/Credit Conversion": "gpa-credit-conversion",
  "Document Translation": "document-translation",
  "Resume Services": "resume-services",
  "Profile Evaluation": "profile-evaluation",
  "Resume & Cover Letter": "resume-cover-letter",
  "International Job Search": "jobs",
  SAT: "sat",
  GRE: "gre",
  GMAT: "gmat",
  "Learn German": "learn-german",
  "IELTS Preparation": "ielts-preparation",
  "TOEFL Preparation": "toefl-preparation",
  "Learn Spanish": "learn-spanish",
  Scholarships: "scholarships",
  Loans: "loans",
  "International Payments": "international-payments",
  "Study & Research Grant": "study-research-grant",
  "Visa Advisory": "visa-advisory",
  "Document Preparation": "document-preparation",
  "Visa Interview Preparation": "visa-interview-preparation",
  Accommodation: "accommodation",
  "Part Time Jobs": "part-time-jobs",
  Internships: "internships",
};

export const CATEGORY_SLUG_TO_NAME_MAP = {
  "study-abroad": "Study Abroad",
  "work-abroad": "Work Abroad",
  "educational-financing": "Education Financing",
  "language-preparation": "Language Preparation",
  "post-landing-support": "Post Landing Support",
  "visa-immigration": "Visa & Immigration",
  "entrance-exam-preparation": "Entrance Exam Preparation",
  "destination-selection": "Destination Selection",
  "program-selection": "Program Selection",
  "sop-assistance": "SOP Assistance",
  "lor-assistance": "LOR Assistance",
  "application-filing": "Application Filing",
  "gpa-credit-conversion": "GPA/Credit Conversion",
  "document-translation": "Document Translation",
  "resume-services": "Resume Services",
  "profile-evaluation": "Profile Evaluation",
  "resume-cover-letter": "Resume & Cover Letter",
  jobs: "International Job Search",
  sat: "SAT",
  gre: "GRE",
  gmat: "GMAT",
  "learn-german": "Learn German",
  "ielts-preparation": "IELTS Preparation",
  "toefl-preparation": "TOEFL Preparation",
  "learn-spanish": "Learn Spanish",
  scholarships: "Scholarships",
  loans: "Loans",
  "international-payments": "International Payments",
  "study-research-grant": "Study & Research Grant",
  "visa-advisory": "Visa Advisory",
  "document-preparation": "Document Preparation",
  "visa-interview-preparation": "Visa Interview Preparation",
  accommodation: "Accommodation",
  "part-time-jobs": "Part Time Jobs",
  internships: "Internships",
};

export const POPULAR_SERVICES = [
  {
    serviceImage: "/home/popular-services/program-selection.webp",
    serviceName: "Program Selection",
    serviceDescription:
      "Get help in selecting the right educational program that aligns your career goals & interests",
    servicePageUrl: "study-abroad",
    offer: "Starts at ₹299",
  },
  {
    serviceImage: "/home/popular-services/application-filing.webp",
    serviceName: "Application Filing",
    serviceDescription:
      "Get support in submitting error-free applications to ensure a successful admission process",
    servicePageUrl: "study-abroad",
    offer: "Starts at ₹1,499",
  },
  {
    serviceImage: "/home/popular-services/ielts.webp",
    serviceName: "IELTS Preparation",
    serviceDescription:
      "Receive expert guidance and support in preparing for the IELTS exam",
    servicePageUrl: "language-preparation",
    offer: "Starts at ₹499",
  },
  {
    serviceImage: "/home/popular-services/document-preparation.webp",
    serviceName: "SOP Assistance",
    serviceDescription:
      "Receive expert assistance in obtaining and perfecting strong Letters of Recommendation",
    servicePageUrl: "study-abroad",
    offer: "Starts at ₹249",
  },
  {
    serviceImage: "/home/popular-services/lor.webp",
    serviceName: "LOR Assistance",
    serviceDescription:
      "Receive expert assistance in obtaining and perfecting strong Letters of Recommendation",
    servicePageUrl: "study-abroad",
    offer: "Starts at ₹249",
  },
  {
    serviceImage: "/home/popular-services/visa-advisory.webp",
    serviceName: "Visa Advisory",
    serviceDescription:
      "Receive guidance on visa requirements, processes & documentation ",
    servicePageUrl: "visa-immigration",
    offer: "Starts at ₹3,999",
  },
  {
    serviceImage: "/home/popular-services/loan.png",
    serviceName: "Loans",
    serviceDescription:
      "Compare and secure the best education loan options from multiple verified lenders",
    servicePageUrl: "education-financing",
    offer: "Starts at ₹499",
  },
  {
    serviceImage: "/home/popular-services/scholarships.webp",
    serviceName: "Scholarships",
    serviceDescription:
      "Get assistance in finding & applying for scholarships to finance your international studies",
    servicePageUrl: "education-financing",
    offer: "Starts at ₹6,999",
  },
  {
    serviceImage: "/home/popular-services/part-time-jobs.webp",
    serviceName: "Part Time Jobs",
    serviceDescription:
      "Find internship opportunities that align with your career goals & provide valuable work experience",
    servicePageUrl: "post-landing-support",
    offer: "Starts at ₹4,999",
  },
  {
    serviceImage: "/home/popular-services/accommodation.webp",
    serviceName: "Accommodation",
    serviceDescription:
      "Get assistance in finding suitable and affordable accommodation options on foreign land",
    servicePageUrl: "post-landing-support",
    offer: "Starts at ₹6,999",
  },
  {
    serviceImage: "/home/popular-services/study-research.webp",
    serviceName: "View All Services",
    serviceDescription:
      "Explore our complete range of services to help you with your study and work abroad journey",
    servicePageUrl: "pricing",
    offer: null,
    isViewAll: true,
  },
];

export const SERVICES = {
  "Study Abroad": [
    {
      serviceImage: "/home/popular-services/program-selection.webp",
      serviceName: "Program Selection",
      serviceDescription:
        "Get help in selecting the right educational program that aligns your career goals & interests",
      servicePageUrl: "study-abroad",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/destination-selection.webp",
      serviceName: "Destination Selection",
      serviceDescription:
        "Find guidance in choosing the best location for your study or work abroad experience",
      servicePageUrl: "study-abroad",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/sop-review.webp",
      serviceName: "SOP Assistance",
      serviceDescription:
        "Have your SOP reviewed & refined to increase your chances of acceptance into desired program",
      servicePageUrl: "study-abroad",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/application-filing.webp",
      serviceName: "Application Filing",
      serviceDescription:
        "Get support in submitting error-free applications to ensure a successful admission process",
      servicePageUrl: "study-abroad",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/lor.webp",
      serviceName: "LOR Assistance",
      serviceDescription:
        "Receive expert assistance in obtaining and perfecting strong Letters of Recommendation",
      servicePageUrl: "study-abroad",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/gpa-credit.webp",
      serviceName: "GPA/Credit Conversion",
      serviceDescription:
        "Convert your academic scores to a format recognized by international institutions",
      servicePageUrl: "study-abroad",
      offer: null,
    },
  ],
  "Work Abroad": [
    {
      serviceImage: "/home/popular-services/international-jobs.webp",
      serviceName: "International Job Search",
      serviceDescription:
        "Expand your horizons and find your dream job worldwide with our global job search platform",
      servicePageUrl: "work-abroad",
      serviceRedirectUrl: "https://www.nbyula.com/jobs",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/resume-builder.webp",
      serviceName: "Resume Builder",
      serviceDescription:
        "Create your professional resume effortlessly with our intuitive resume builder app",
      servicePageUrl: "work-abroad",
      serviceRedirectUrl: "https://resume.nbyula.com",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/profile-evaluation.webp",
      serviceName: "Profile Evaluation",
      serviceDescription:
        "Receive an expert evaluation of your academic & professional profile",
      servicePageUrl: "work-abroad",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/resume-cover-letter.webp",
      serviceName: "Resume & Cover Letter",
      serviceDescription:
        "Get assistance crafting a compelling resume & cover letter for the international job-market",
      servicePageUrl: "work-abroad",
      offer: null,
    },
  ],
  "Language Preparation": [
    {
      serviceImage: "/home/popular-services/ielts.webp",
      serviceName: "IELTS Preparation",
      serviceDescription:
        "Receive expert guidance and support in preparing for the IELTS exam",
      servicePageUrl: "language-preparation",
      offer: "Starts at ₹299",
    },
    {
      serviceImage: "/home/popular-services/toefl.webp",
      serviceName: "TOEFL Preparation",
      serviceDescription:
        "Prepare for the TOEFL exam with expert guidnace & support",
      servicePageUrl: "language-preparation",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/learn-spanish.webp",
      serviceName: "Learn Spanish",
      serviceDescription:
        "Learn the Spanish language to increase your chances of acceptance into Spanish institutes",
      servicePageUrl: "language-preparation",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/learn-german.webp",
      serviceName: "Learn German",
      serviceDescription:
        "Learn The German Language to increase your chances of acceptance into German institutes",
      servicePageUrl: "language-preparation",
      offer: null,
    },
  ],
  "Education Financing": [
    {
      serviceImage: "/home/popular-services/scholarships.webp",
      serviceName: "Scholarships",
      serviceDescription:
        "Get assistance in finding & applying for scholarships to finance your international studies",
      servicePageUrl: "education-financing",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/loan.png",
      serviceName: "Loans",
      serviceDescription:
        "Compare and secure the best education loan options from multiple verified lenders",
      servicePageUrl: "education-financing",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/remitance.png",
      serviceName: "International Payments",
      serviceDescription:
        "Send tuition fees and payments abroad securely with competitive exchange rates",
      servicePageUrl: "education-financing",
      offer: null,
    },
  ],
  "Visa & Immigration": [
    {
      serviceImage: "/home/popular-services/visa-advisory.webp",
      serviceName: "Visa Advisory",
      serviceDescription:
        "Receive guidance on visa requirements, processes & documentation ",
      servicePageUrl: "visa-immigration",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/document-preparation.webp",
      serviceName: "Document Preparation",
      serviceDescription:
        "Get support in preparing the necessary documentation for international study & work",
      servicePageUrl: "visa-immigration",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/visa-interview.webp",
      serviceName: "Visa Interview Preparation",
      serviceDescription:
        "Get guidance & coaching to ace your visa interview and increase your chances of approval",
      servicePageUrl: "visa-immigration",
      offer: null,
    },
  ],
  "Post Landing Support": [
    {
      serviceImage: "/home/popular-services/accommodation.webp",
      serviceName: "Accommodation",
      serviceDescription:
        "Get assistance in finding suitable and affordable accommodation options on foreign land",
      servicePageUrl: "post-landing-support",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/internships.webp",
      serviceName: "Internships",
      serviceDescription:
        "Find part-time job opportunities that can supplement your income & gain valuable work experience",
      servicePageUrl: "post-landing-support",
      offer: null,
    },
    {
      serviceImage: "/home/popular-services/part-time-jobs.webp",
      serviceName: "Part Time Jobs",
      serviceDescription:
        "Find internship opportunities that align with your career goals & provide valuable work experience",
      servicePageUrl: "post-landing-support",
      offer: null,
    },
  ],
};

export const TRENDING_DISCUSSIONS_BY_SLUG = [
  "what-are-some-tips-for-international-students-who-are-planning-to-pursue-an-ms-in-computer-science-in-the-uk",
  "what-is-the-best-way-to-select-an-ms-in-computer-science-program-in-the-uk",
  "how-to-make-an-sop-unique-and-make-it-stand-out-from-other-applicants",
  "how-much-can-an-indian-student-earn-in-uk",
];

export const TOP_RATED_MENTORS = [
  {
    username: "yasir2",
    videoId: "PNqPoZqevMA",
  },
  {
    username: "aarohi-1",
    videoId: "5YX9cByx2wI",
  },
  {
    username: "debayan-1",
    videoId: "rrz_Hr7QoCw",
  },
  {
    username: "vighnesh-1",
    videoId: "IpiKq3dPygI",
  },
  {
    username: "maitri-2",
    videoId: "AJabRE_JPh0",
  },
];

export const EXCEPT_THIS_SYMBOLS = ["e", "E", "+", "-"];

export const ONE_ON_ONE_DURATION_OPTIONS = [
  {
    value: 30,
    label: "30 min",
  },
  {
    value: 45,
    label: "45 min",
  },
  {
    value: 60,
    label: "60 min",
  },
];

export const ONE_ON_ONE_DURATIONS = [30, 45, 60];

export const MEETING_TYPE = {
  CHAT: 1,
  VIDEO: 2,
};

export const MEETING_TYPE_OPTIONS = [
  {
    value: MEETING_TYPE.CHAT,
    label: "Chat Based Guidance",
    description: "Connect with your mentor through text messages",
  },
  {
    value: MEETING_TYPE.VIDEO,
    label: "Video Conference",
    description: "Join a video call with your mentor",
  },
];
